import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import Home from './views/Home.vue'
import store from '@/store'
import NProgress from 'nprogress'

Vue.use(Router)
Vue.use(Meta)

var router = new Router({
  mode: 'history',
  routes: [{
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/account/dashboard',
      name: 'AccountDashboard',
      component: () => import( /* webpackChunkName: "AccountDashboard" */ './views/AccountDashboard.vue')
    },
    {
      path: '/forfun',
      name: 'ForfunServerList',
      component: () => import( /* webpackChunkName: "ForfunServerList" */ './views/ForfunServerList.vue')
    },
    {
      path: '/discord',
      name: 'Discord',
      component: () => import( /* webpackChunkName: "Blog" */ './views/Discord.vue')
    },
    {
      path: '/loadout',
      name: 'Loadout',
      component: () => import( /* webpackChunkName: "Blog" */ './views/Loadout.vue')
    },
    {
      path: '/premium',
      name: 'PremiumPage',
      component: () => import( /* webpackChunkName: "PremiumPage" */ './views/PremiumPage.vue')
    },
    {
      path: '/forfun_stats',
      name: 'ForfunStats',
      component: () => import( /* webpackChunkName: "ForfunStats" */ './views/ForfunStats.vue')
    },
    {
      path: '/ranked_stats',
      name: 'RankedStats',
      component: () => import( /* webpackChunkName: "RankedStats" */ './views/RankedStats.vue')
    },
    {
      path: '/teams',
      name: 'TeamList',
      component: () => import( /* webpackChunkName: "TeamList" */ './views/TeamList.vue')
    },
    {
      path: '/teams/new',
      name: 'TeamCreate',
      component: () => import( /* webpackChunkName: "TeamCreate" */ './views/TeamCreate.vue')
    },
    {
      path: '/teams/:id',
      name: 'TeamSingle',
      component: () => import( /* webpackChunkName: "TeamSingle" */ './views/TeamSingle.vue')
    },
    {
      path: '/blogposts',
      name: 'BlogpostList',
      component: () => import( /* webpackChunkName: "BlogpostList" */ './views/BlogpostList.vue'),
      meta: {
        bodyClass: 'blogpost-page'
      }
    },
    {
      path: '/blogposts/:id',
      name: 'BlogpostSingle',
      component: () => import( /* webpackChunkName: "BlogpostSingle" */ './views/BlogpostSingle.vue')
    },
    {
      path: '/forum',
      name: 'ForumList',
      component: () => import( /* webpackChunkName: "ForumList" */ './views/ForumList.vue')
    },
    {
      path: '/forum/new',
      name: 'ForumCreate',
      component: () => import( /* webpackChunkName: "ForumCreate" */ './views/ForumCreate.vue')
    },
    {
      path: '/forum/:id',
      name: 'ForumSingle',
      component: () => import( /* webpackChunkName: "ForumSingle" */ './views/ForumSingle.vue')
    },
    {
      path: '/lobbies',
      name: 'LobbyList',
      component: () => import( /* webpackChunkName: "LobbyList" */ './views/LobbyList.vue')
    },
    {
      path: '/lobbies/:id',
      name: 'LobbySingle',
      component: () => import( /* webpackChunkName: "LobbySingle" */ './views/LobbySingle.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/practice',
      name: 'PracticeList',
      component: () => import( /* webpackChunkName: "PracticeList" */ './views/PracticeList.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/rooms',
      name: 'RoomList',
      component: () => import( /* webpackChunkName: "RoomList" */ './views/RoomList.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/rooms/:id',
      name: 'RoomSingle',
      component: () => import( /* webpackChunkName: "RoomSingle" */ './views/RoomSingle.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tournaments',
      name: 'TournamentList',
      component: () => import( /* webpackChunkName: "TournamentList" */ './views/TournamentList.vue'),
      meta: {
        bodyClass: 'tournament-page'
        //   requiresAuth: true
      }
    },
    {
      path: '/tournaments/:id/bracket',
      name: 'TournamentBracket',
      component: () => import( /* webpackChunkName: "TournamentBracket" */ './views/TournamentBracket.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tournaments/:id/matches',
      name: 'TournamentMatches',
      component: () => import( /* webpackChunkName: "TournamentMatches" */ './views/TournamentMatches.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tournaments/:id/stats',
      name: 'TournamentStats',
      component: () => import( /* webpackChunkName: "TournamentStats" */ './views/TournamentStats.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tournaments/:id/admin',
      name: 'TournamentAdmin',
      component: () => import( /* webpackChunkName: "TournamentAdmin" */ './views/TournamentAdmin.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tournaments/:id/edit',
      name: 'TournamentEdit',
      component: () => import( /* webpackChunkName: "TournamentCreate" */ './views/TournamentCreate.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tournaments/new',
      name: 'TournamentCreate',
      component: () => import( /* webpackChunkName: "TournamentCreate" */ './views/TournamentCreate.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tournaments/:id',
      name: 'TournamentSingle',
      component: () => import( /* webpackChunkName: "TournamentSingle" */ './views/TournamentSingle.vue')
    },
    {
      path: '/clubs',
      name: 'ClubList',
      component: () => import( /* webpackChunkName: "ClubList" */ './views/ClubList.vue'),
      meta: {
        bodyClass: 'clubs-page'
      }
    },
    {
      path: '/clubs/:id/stats',
      name: 'ClubStats',
      component: () => import( /* webpackChunkName: "ClubStats" */ './views/ClubStats.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/clubs/:id/lobbies',
      name: 'ClubLobbies',
      component: () => import( /* webpackChunkName: "ClubLobbies" */ './views/ClubLobbies.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/clubs/:id',
      name: 'ClubSingle',
      component: () => import( /* webpackChunkName: "ClubSingle" */ './views/ClubSingle.vue'),
      meta: {
        bodyClass: 'clubs-single-page'
      }
    },
    {
      path: '/users/:id',
      name: 'UserSingle',
      component: () => import( /* webpackChunkName: "UserSingle" */ './views/UserSingle.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/notifications',
      name: 'NotificationList',
      component: () => import( /* webpackChunkName: "NotificationList" */ './views/NotificationList.vue'),
      meta: {
        requiresAuth: true,
        bodyClass: 'notifications-page'
      }
    },
    {
      path: '/notifications/:id',
      name: 'NotificationSingle',
      component: () => import( /* webpackChunkName: "NotificationSingle" */ './views/NotificationSingle.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/wall_of_shame',
      name: 'WallOfShame',
      component: () => import( /* webpackChunkName: "WallOfShame" */ './views/WallOfShame.vue'),
    },
    {
      path: '/suporte',
      name: 'Support',
      component: () => import( /* webpackChunkName: "Support" */ './views/Support.vue'),
      meta: {
        bodyClass: 'support-page'
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import( /* webpackChunkName: "Login" */ './views/Login.vue'),
      meta: {
        bodyClass: 'login-page'
      }
    }
  ]
})

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start()
  }
  next()
})

router.afterEach((to, from) => {
  // Complete the animation of the route progress bar.
  NProgress.done()
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    } else {
      return next({ path: '/login', query: { returnUrl: to.path } });
    }

  } else {
    next()
  }
})

export default router;
